import moment, { Moment } from "moment";
import { IAccessRules, IAccessRulesWithBookableUntil, IMobileAccessRules } from "types";
import { convertFromIso8601ToMoment } from "./date-time-iso-8601-converter";

export const isResourceBookableByUser = (
  officeTimeZone: string,
  accessRules?: IAccessRules | IAccessRulesWithBookableUntil | IMobileAccessRules,
  bookingDate?: Moment | null,
): boolean => {
  if (!accessRules) {
    return true;
  }
  if ("isBookable" in accessRules && typeof accessRules.isBookable === "boolean") {
    // Mobile clients send only { isBookable: boolean } (IMobileAccessRules).
    // The old availability endpoint also provided this pre-computed flag.
    // In both cases there is no need to re-evaluate restrictions here.
    return accessRules.isBookable;
  }

  // In the latest endpoints, resourcesBookableUntil is accommodating both lead time and access rules, but we need to check is resource is bookable based on the point of time for which the user wants to book for
  if (!bookingDate) {
    return accessRules.userHasAccess;
  }

  // Use the date when the user wants to book for check if the resource is bookable
  if (
    accessRules.restrictedTime !== null &&
    accessRules.restrictedTime !== undefined &&
    accessRules.resourcesBookableUntil
  ) {
    const nowInOffice = moment().tz(officeTimeZone);
    const selectedDateInOffice = bookingDate ? moment(bookingDate).tz(officeTimeZone) : null;
    const bookingTime = selectedDateInOffice
      ? selectedDateInOffice.isSame(nowInOffice, "day")
        ? nowInOffice
        : selectedDateInOffice.endOf("day")
      : nowInOffice;
    const resourcesBookableUntil = convertFromIso8601ToMoment(accessRules.resourcesBookableUntil, officeTimeZone);

    return resourcesBookableUntil.isSameOrAfter(bookingTime);
  } else {
    return accessRules.userHasAccess;
  }
};
